import type React from 'react';

import { Breadcrumbs } from '@change/ds-core-ui/Breadcrumbs';
import { Link } from '@change/ds-core-ui/Link';
import { Text } from '@change/ds-core-ui/Text';

import { Translate, TranslateHtml } from '@change-corgi/core-react/i18n';

import { usePageBody } from './hooks/usePageBody';

export const PageBody: React.FC<EmptyProps> = () => {
	const {
		data: { breadcrumbItems },
	} = usePageBody();
	return (
		<div className="container mb-10">
			<Text variant="heading" as="h2" size="medium" className="mt-8 font-normal">
				<Translate value="fe.pages.open_platform.description" />
			</Text>
			<Text as="p" className="mt-4">
				<Translate value="fe.pages.open_platform.p1" />
			</Text>
			<Text as="p" className="mt-4 mb-10">
				<TranslateHtml
					value="fe.pages.open_platform.p2"
					replacements={{
						p2_link: (
							<Link href="/policies/community" data-qa="policies-link">
								<Translate value="fe.pages.open_platform.p2_link_text" />
							</Link>
						),
					}}
				/>
			</Text>
			<Breadcrumbs items={breadcrumbItems} maxVisible={2} maxVisibleTablet={1} />
		</div>
	);
};
